// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1a5Lz","dragIcon":"Choice_dragIcon__f0aaC","left":"Choice_left__1YgSk","input":"Choice_input__1imij"};